import { consented } from "./consent"

const getStorage = (storageType, itemKey, consentType) => {
  if (consented(consentType)) {
    const value = storageType.getItem(itemKey)

    try {
      return JSON.parse(value)
    } catch (error) {
      return value
    }
  }
}

const setStorage = (storageType, itemKey, itemValue, consentType) => {
  if (consented(consentType)) {
    return storageType.setItem(itemKey, itemValue)
  }
}

const removeStorage = (storageType, itemKey, consentType) => {
  if (consented(consentType)) {
    storageType.removeItem(itemKey)
  }
}

export const setLocalStorageWithConsent = (itemKey, itemValue, consentType) =>
  // eslint-disable-next-line no-storage/no-browser-storage
  setStorage(window.localStorage, itemKey, itemValue, consentType)

export const getLocalStorageWithConsent = (itemKey, consentType) =>
  // eslint-disable-next-line no-storage/no-browser-storage
  getStorage(window.localStorage, itemKey, consentType)

export const setSessionStorageWithConsent = (itemKey, itemValue, consentType) =>
  // eslint-disable-next-line no-storage/no-browser-storage
  setStorage(window.sessionStorage, itemKey, itemValue, consentType)

export const getSessionStorageWithConsent = (itemKey, consentType) =>
  // eslint-disable-next-line no-storage/no-browser-storage
  getStorage(window.sessionStorage, itemKey, consentType)

export const removeSessionStorageWithConsent = (itemKey, consentType) =>
  // eslint-disable-next-line no-storage/no-browser-storage
  removeStorage(window.sessionStorage, itemKey, consentType)
